import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CSVLink } from 'react-csv';
import {
  Button,
  Icon,
  Tooltip
} from '@material-ui/core';
import { getGiftCodesApi } from 'api';


const ExportGiftCodesToCSV = () => {
  const dispatch = useDispatch();

  const {
    giftCodesCSVData,
    giftCodesListCount
  } = useSelector((state: IReduxState) => state.gift_card);

  useEffect(() => {
    if (!giftCodesCSVData.length) {
      getGiftCodesApi({
        dispatch,
        sortDirection: 'desc',
        sortField: 'created_at',
        pageSize: 0,
        currentPage: 0,
        filterConditions: [],
        searchConditions: [],
        isCSVData: true
      });
    }
  }, [giftCodesListCount]);

  return (
    <div>
      <Tooltip title="Download CSV">
        <CSVLink
          data={giftCodesCSVData}
          className="flex items-center"
          filename={'gift_codes.csv'}
          onClick={() => !!giftCodesCSVData.length}
        >
          <Button
            variant="outlined"
            color="primary"
            disabled={!giftCodesCSVData.length}
            className="ml-2"
          >
            <Icon className={`${!!giftCodesCSVData.length ? 'text-primary' : null} mr-2`}>
              cloud_download
            </Icon>
            <span className={`${!!giftCodesCSVData.length ? 'text-brand' : ''}`}>
              Download
            </span>
          </Button>
        </CSVLink>
      </Tooltip>
    </div>
  );
};

export default ExportGiftCodesToCSV;
